import { OfflineStorage } from "./estrylib";
export const Electricity = "Electricity";
export const Cellulars = "Cellulars";
export const Water = "Water";
export const Gaz = "Gaz";
export const Internet = "Internet";
export const Rent = "Rent";
export const Maintenance = "Maintenance";
export const Salaries = "Salaries";
export const Food = "Food";
export const Hospitality = "Hospitality";
export const FinancialConsultant = "FinancialConsultant";
export const Marketing = "Marketing";
export const OfficeEquipments = "OfficeEquipments";
export const CleaningKits = "CleaningKits";
export const DevelopmentServices = "DevelopmentServices";
export const Discounts = "Discounts";
export const Traffic = "Traffic";
export const Other = "Other";

export const ExpenseCategories = [
  {
    label: window.sys_app_translate(
      "Electricity",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Electricity,
  },
  {
    label: window.sys_app_translate(
      "Cellulars",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Cellulars,
  },
  {
    label: window.sys_app_translate(
      "Water",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Water,
  },
  {
    label: window.sys_app_translate(
      "Gaz",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Gaz,
  },
  {
    label: window.sys_app_translate(
      "Internet",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Internet,
  },
  {
    label: window.sys_app_translate(
      "Rent",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Rent,
  },
  {
    label: window.sys_app_translate(
      "Maintenance",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Maintenance,
  },
  {
    label: window.sys_app_translate(
      "Salaries",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Salaries,
  },
  {
    label: window.sys_app_translate(
      "Food",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Food,
  },
  {
    label: window.sys_app_translate(
      "Hospitality",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Hospitality,
  },
  {
    label: window.sys_app_translate(
      "FinancialConsultant",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: FinancialConsultant,
  },
  {
    label: window.sys_app_translate(
      "Marketing",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Marketing,
  },
  {
    label: window.sys_app_translate(
      "OfficeEquipments",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: OfficeEquipments,
  },
  {
    label: window.sys_app_translate(
      "Traffic",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Traffic,
  },
  {
    label: window.sys_app_translate(
      "DevelopmentServices",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: DevelopmentServices,
  },
  {
    label: window.sys_app_translate(
      "Discounts",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Discounts,
  },
  {
    label: window.sys_app_translate(
      "CleaningKits",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: CleaningKits,
  },
  {
    label: window.sys_app_translate(
      "Other",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: Other,
  },
];
